export default __webpack_public_path__ + "static/media/cream-wave-1.16d8c6ed.svg";